import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { marketStockExchangeSlice } from '!views/Market/StockExchange/_marketStockExchange.slice';
import { getSelectedTitle } from '!views/Market/StockExchange/marketStockExchange.seletors';

import { TrlStockExchangeMarketDesc } from '../TrlStockExchangeMarketDesc';
import { Wrapper } from './TrlCardSmall.styles';

export const TrlCardSmall = ({ data }) => {
  const dispatch = useDispatch();

  const selectedTitle = useSelector(getSelectedTitle);

  const selected = data.id === selectedTitle.id;

  const handleSelectedCard = () => {
    dispatch(marketStockExchangeSlice.actions.setSelectedTitle(data));
  };

  return (
    <Wrapper
      onClick={handleSelectedCard}
      isSelected={selected}
      variationPctg={data.variationPctg}
    >
      <TrlStockExchangeMarketDesc
        instrument={data.instrument}
        descr={data.descr || data.securityDescription}
        symbol={data.symbol}
        exchange={data.exchange}
        exchangeDescr={data.exchangeDescr}
        country={data.country}
        lastPx={data.lastPx}
        lastDateTime={data.lastDateTime}
        totalVolumeTraded={data.totalVolumeTraded}
        nominalValue={data.nominalValue}
        variationPctg={data.variationPctg}
        priceRepresentation={data.priceRepresentation}
        quantityRepresentation={data.quantityRepresentation}
        securityType={data.securityType}
        askPx={data.askPx}
        bidPx={data.bidPx}
        highPx={data.highPx}
        lowPx={data.lowPx}
        isCard
        isFavorite={data.isFavourite === 'Y'}
        currency={data.currency}
        chartData={data.chartData}
        canTrade={data.canTrade}
        roundPrice={data.roundPrice}
      />
    </Wrapper>
  );
};

TrlCardSmall.propTypes = {
  data: PropTypes.object.isRequired,
};
